
export default function SearchBar({ searchValue, setSearchValue, placeHolder, options, onSearch }) {
  const handleChange = (event) => {
    event.preventDefault();
    setSearchValue(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (onSearch) onSearch(event);
    }
  };

  return (
    <div>
      <input 
        id="search-input"
        type="text" 
        placeholder={placeHolder} 
        value={searchValue} 
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        list="searchOptions"
        aria-label="Search input"
      />
      <datalist id="searchOptions">
        {options && options.map((option) => (
          <option key={option.id} value={option.name} />
        ))}
      </datalist>
      <button onClick={() => setSearchValue('')} disabled={!searchValue}>Clear</button>
    </div>
  );
}
